<template>
    <stick-pop v-bind="$attrs" @click="show">
        <i class="el-icon-collection-tag" style="font-weight: 600"></i>
    </stick-pop>
</template>

<script>
    import StickPop from "./StickPop";
    import {getMyHeader, isHybridAgent} from "../../../utils";
    import { CachedApiSecurity } from "../../../api-security";

    export default {
        name: "Follows",
        components: {StickPop},
        methods: {
            show(){
                if (!CachedApiSecurity.isSignedIn()){
                    CachedApiSecurity.handleNoAuthorith();
                }else
                    getMyHeader().$refs.myFollows.show();
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/stickpops/Follows.vue